<section
    class="flex flex-col transition-opacity lg:inner-page-wrapper lg:flex-row lg:gap-56 lg:py-40"
    [ngClass]="{ 'opacity-0': isLoading() }"
>
    <div class="relative w-full transition-all lg:max-w-[500px] xl:max-w-[580px]">
        <ui-m000-c010-image
            class="block w-full bg-white lg:aspect-[4/3]"
            [alt]="vehicle().name + ' Vorschau Bild'"
            [image]="{
                image: vehicle().images[0],
                mobile: { width: 767, height: 575 },
                tablet: { width: 1022, height: 766 },
                desktop: { width: 580, height: 435 },
            }"
            [classList]="'w-full max-h-[260px] lg:max-h-[435px] object-contain'"
            priority
            cover
            highRes
        />
        <div class="absolute bottom-16 right-16 lg:relative lg:bottom-0 lg:right-0">
            <ui-m030-c160-vehicle-gallery
                [images]="vehicle().images"
                [isFirstView]="!(viewport.isMobile() || viewport.isTablet())"
            />
        </div>
    </div>

    <div class="contents lg:flex lg:flex-1 lg:flex-col lg:gap-x-24">
        <div class="flex items-start justify-between gap-16">
            <div class="flex flex-col gap-8 px-24 pt-16 lg:p-0">
                <h1 class="text-18 leading-27">{{ vehicle().name }}</h1>
            </div>

            <button (click)="share()">
                <i class="icon-share-symbol p-[18px] text-[32px] text-black lg:p-0"></i>
            </button>
        </div>

        <div class="flex flex-col gap-8 px-24 pb-16 lg:p-0">
            <div class="mt-auto flex flex-1 flex-wrap items-center gap-12">
                @if (vehicle().meta.promise) {
                    <button
                        class="flex items-center gap-6 bg-accent px-8 py-2 text-12 text-white"
                        (click)="openPromiseOverlay()"
                    >
                        Hyundai Promise
                        <i class="icon-info"></i>
                    </button>
                }
                @if (vehicle().meta.batteryCertified) {
                    <button
                        class="flex items-center gap-6 bg-grey-200 px-8 py-2 text-12 text-black"
                        (click)="openBatteryOverlay()"
                    >
                        Batterie Zertifikat
                        <i class="icon-info"></i>
                    </button>
                }
            </div>

            <span class="flex items-center gap-6 text-16 font-medium text-accent">
                <i class="icon-location"></i>
                {{ vehicle().location.city }}
            </span>

            <div class="flex max-w-[350px] justify-between gap-12 text-16 leading-27">
                <div class="flex space-x-8">
                    {{ this.vehicle().tags.join(' | ') }}
                </div>
                <a class="text-accent underline" [hyundaiRouterLink]="'.'" [fragment]="'details'">mehr Details</a>
            </div>
            <p class="text-14 leading-20">{{ vehicle().envkvString }}</p>
            <div class="flex flex-col gap-24 bg-grey-100 p-24 pt-16 md:max-w-[350px]">
                <div class="flex flex-1 shrink-0 flex-col">
                    <span class="text-16 leading-27">Kaufpreis</span>
                    <span class="flex items-end gap-4">
                        <span class="font-headline text-31 font-medium leading-36">
                            {{ vehicle().price.buy | currency: 'EUR' : '' : '1.0-0' }}
                        </span>
                        <span class="text-14 font-medium uppercase leading-[21px]">EUR</span>
                    </span>
                </div>
                <a
                    class="button-primary"
                    [hyundaiRouterLink]="'haendleranfrage'"
                    [trackingElTarget]="'haendleranfrage?tab=probefahrt'"
                    [queryParams]="{ tab: 'probefahrt' }"
                    tracking
                    trackingElLabel="Test Drive"
                    trackingElType="button"
                    trackingEvent="element_click"
                >
                    Probefahrt vereinbaren
                </a>
            </div>
        </div>
    </div>
</section>

<section class="relative z-[11] mb-[-73px] bg-grey-500">
    <div class="inner-page-wrapper flex flex-col gap-16 pb-32 pt-24 lg:flex-row lg:justify-between lg:gap-0 lg:py-32">
        <div class="flex flex-col gap-4">
            <h3 class="text-18 leading-27 lg:text-20 lg:leading-30">{{ vehicle().dealer.name }}</h3>

            @let location = vehicle().dealer.location;
            <div class="text-16 leading-27">
                <p>{{ location.street }} {{ location.buildingNumber }}</p>
                <p>{{ location.zip }} {{ location.city }}</p>
            </div>
        </div>
        <div class="flex flex-col gap-10 text-16 leading-20 text-accent">
            <a
                class="flex items-center gap-8 font-headline"
                [hyundaiRouterLink]="'tel:' + vehicle().dealer.phone"
                [trackingElTarget]="'tel:' + vehicle().dealer.phone"
                [trackingVehicle]="vehicle()"
                tracking
                trackingElLabel="Contact"
                trackingElType="basic link"
                trackingEvent="engagement_click"
            >
                <i class="icon-phone text-24"></i>
                <span>{{ vehicle().dealer.phone }}</span>
            </a>
            <a
                class="flex items-center gap-8 font-headline"
                [hyundaiRouterLink]="vehicle().dealer.location.googleMapsLink"
                [trackingElTarget]="vehicle().dealer.location.googleMapsLink"
                trackingElType="basic link"
                tracking
                trackingElLabel="Location"
            >
                <i class="icon-location text-24"></i>
                <span>Anfahrt</span>
            </a>
            @if (isHCM) {
                <a
                    class="flex items-center gap-8 font-headline"
                    [hyundaiRouterLink]="'/fahrzeugbestand'"
                    [queryParams]="{ filter: dealerParams() }"
                    [trackingElTarget]="'/fahrzeugbestand?filter=' + dealerParams()"
                    trackingElType="basic link"
                    tracking
                    trackingElLabel="Vehicle Markt List"
                >
                    <i class="icon-car text-24"></i>
                    <span>Händlerbestand</span>
                </a>
                <button class="flex items-center gap-8 font-headline" (click)="openImprintOverlay()">
                    <span class="flex w-24 items-center justify-center">
                        <i class="icon-globe text-18"></i>
                    </span>
                    <span>Händlerimpressum</span>
                </button>
            }
        </div>
    </div>
</section>

<section class="sticky top-[50px] z-10 flex w-full gap-8 bg-white px-24 py-12 shadow-sm lg:ml-auto lg:max-w-[400px]">
    <div class="mr-auto flex flex-col">
        <h4 class="leading-22 truncate text-16">{{ vehicle().shortName }}</h4>
        <h4 class="text-20 leading-25">{{ vehicle().price.buy | currency: 'EUR' : '' : '1.0-0' }} EUR</h4>
    </div>

    <a
        class="flex size-[50px] items-center justify-center border-2 border-accent p-6 text-accent transition-colors hover:bg-grey-300"
        [hyundaiRouterLink]="'haendleranfrage'"
        [trackingElTarget]="'haendleranfrage?tab=allg-anfrage'"
        [trackingVehicle]="vehicle()"
        [queryParams]="{ tab: 'allg-anfrage' }"
        tracking
        trackingElLabel="Contact (email)"
        trackingElType="button"
        trackingEvent="engagement_click"
    >
        <i class="icon-mail text-40"></i>
    </a>
    <a
        class="flex size-[50px] items-center justify-center border-2 border-accent bg-accent p-6 text-white transition-colors hover:bg-accent-cta-hover"
        [hyundaiRouterLink]="'tel:' + vehicle().dealer.phone"
        [trackingElTarget]="'tel:' + vehicle().dealer.phone"
        [trackingVehicle]="vehicle()"
        tracking
        trackingElLabel="Contact"
        trackingElType="button"
        trackingEvent="engagement_click"
    >
        <i class="icon-phone text-40"></i>
    </a>
</section>

@if (vehicle().promise; as promise) {
    <section class="bg-grey-100">
        <div class="inner-page-wrapper flex flex-col gap-16 py-24 lg:flex-row lg:justify-between lg:gap-0 lg:py-32">
            <div class="flex items-center justify-between lg:flex-col lg:items-start lg:justify-start lg:gap-12">
                <h3 class="text-18 leading-27 lg:text-34 lg:leading-41">Hyundai Promise Vorteile</h3>
                <button ui-m010-c020-icon-link class="shrink-0" (click)="openPromiseOverlay()">mehr dazu</button>
            </div>

            <div class="lg:gap-80 grid grid-cols-3 gap-16">
                @for (item of promise; track item.id) {
                    <div class="flex flex-col items-center gap-5">
                        <ui-m000-c010-image
                            class="block h-[40px] w-[54px] md:h-[67px] md:w-[90px]"
                            [image]="{
                                image: item.icon,
                                mobile: { width: 54, height: 40 },
                                tablet: { width: 90, height: 67 },
                                desktop: { width: 90, height: 67 },
                            }"
                            [alt]="item.label + ' Icon'"
                            [classList]="'block h-[40px] w-[54px] md:h-[67px] md:w-[90px]'"
                            priority
                            highRes
                        />
                        <span
                            class="text-center text-14 font-medium leading-20 lg:font-headline lg:text-18 lg:font-normal lg:leading-27"
                        >
                            {{ item.label }}
                        </span>
                    </div>
                }
            </div>
        </div>
    </section>
}

<lib-vehicle-detail-infos id="details" />

@defer {
    @if (vehicle().dealer.hasShop && vehicle().model) {
        <section class="inner-page-wrapper block" [id]="'shop'">
            <h3 class="leading-29 text-24 lg:text-34 lg:leading-41">Passendes Zubehör</h3>
            <p class="mt-24 text-16 leading-27">
                Wählen Sie hier passendes Orginial Hyundai Zubehör aus und konfigurieren Sie Ihr Wunschfahrzeug. Das
                ausgewählte Zubehör wird zusammen mit der Fahrzeuganfrage an den Hyundai Partner gesendet
            </p>
            <lib-vehicle-equipment
                class="-mx-24 block"
                id="pxc-shop-embed-vehicle-equipment"
                [dealerId]="vehicle().dealer.id"
                [series]="vehicle().model ?? ''"
                [modelyear]="vehicle().modelyear"
            />
        </section>
    }
}

@defer (on viewport; on timer(5s)) {
    @if (similarVehicles(); as similarVehicles) {
        @let link = linkToVehicleList();

        <lib-similar-vehicles [similarVehicles]="similarVehicles.vehicles" title="Ähnliche Fahrzeuge">
            <a
                class="button-primary mx-auto mt-[88px] w-max"
                [hyundaiRouterLink]="link"
                [queryParams]="similarVehiclesFilter()"
                [trackingElTarget]="link"
                [trackingElLabel]="link"
                tracking
                trackingElType="button"
                trackingEvent="element_click"
                link
            >
                Zum Fahrzeugbestand
            </a>
        </lib-similar-vehicles>
    }
} @placeholder {
    <div class="flex min-h-[830px] items-center justify-center">
        <ui-m000-c040-loading-spinner />
    </div>
}
